<template>
    <v-app>
        <crewplanning-core-app-bar v-model="expandOnHover" v-if="get_shared_Path === 'Crewplanning'" />

        <crewplanning-core-drawer :expand-on-hover.sync="expandOnHover" />

        <crewplanning-core-view />

        <crewplanning-core-footer />

        <!-- <crewplanning-core-settings v-model="expandOnHover" v-if="get_shared_Path === 'Crewplanning'" /> -->
        <crewplanning-warnings-list v-model="expandOnHover" v-if="get_shared_Path === 'Crewplanning'" />
    </v-app>
</template>

<script>
    import { mapGetters } from 'vuex';


    export default {
        name: 'CrewplanningIndex',

        /* >>> *************************************************************** / /* Components */
        components: {

            CrewplanningCoreAppBar: () => import('./crewplanning/components/core/AppBar'),              // local

            CrewplanningCoreDrawer: () => import('@/components/core/Drawer'),                           // global
            CrewplanningCoreView: () => import('@/components/core/View'),                               // global
            CrewplanningCoreFooter: () => import('@/components/core/Footer'),                           // global

            // CrewplanningCoreSettings: () => import('@/components/core/Settings'),                    // global
            CrewplanningWarningsList: () => import('./crewplanning/components/calendar/WarningsList'),  // local

        }, // eo components{}
        /* <<< ****************************************************************/



        /* >>> *************************************************************** / /* Data */
        data: () => ({

            expandOnHover: true

        }), // eo function data()
        /* <<< ****************************************************************/



		/* >>> *************************************************************** / /* Computed */
		computed: {

			...mapGetters([
				'get_shared_Path',
			]),

		}, // eo computed{}
		/* <<< ****************************************************************/

    };
</script>
